'use strict';

const sortingPbUtils = require('../../modules/utils/sorting.pb.utils');
function hasToResetFilters(filtersState) {
    const numFilteredResults = Odigeo._.get(filtersState, 'accommodationSearchResultsMetadata.numFilteredResults');
    const numResults = Odigeo._.get(filtersState, 'accommodationSearchResultsMetadata.numResults');

    return !this.widget.options.hasAccommodationFilterPreserved || numFilteredResults === numResults;
}

module.exports = Odigeo.Model.extend({
    dataUrl: '',
    filterUrl: 'accommodation/filter',
    resetUrl: 'accommodation/filter/reset',

    init: function() {
        this.on('change', this.requestFilterAction);
    },

    url: function() {
        return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataUrl);
    },

    requestResetAction: function() {
        this.dataUrl = this.resetUrl + sortingPbUtils.preselectedParameters();
        this.event = 'Reset';
        return this.fetch({
            success: Odigeo._.bind(this.successCallback, this),
            error: Odigeo._.bind(this.errorCallback, this),
        });
    },

    requestFilter: function(data) {
        this.dataUrl = this.filterUrl + sortingPbUtils.preselectedParameters();
        this.event = 'Filter';
        return this.save(data, {
            success: Odigeo._.bind(this.successCallback, this),
            error: Odigeo._.bind(this.errorCallback, this),
        });
    },

    requestFilterAction: function() {
        this.requestFilter(this.changed);
    },

    sync: function() {
        Odigeo.trigger(this.widget.id + ':filterRequestPerformed');

        return Odigeo.Model.prototype.sync.apply(this, arguments).always(
            Odigeo._.bind(function() {
                Odigeo.trigger(this.widget.id + ':filterRequestCompleted');
            }, this)
        );
    },

    /**
     * Overrides Backbone toJSON method. We only need to send to the server changed properties. Information sent to the REST service.
     * @override
     */
    toJSON: function() {
        return Odigeo._.pick(this.attributes, Odigeo._.keys(this.changed));
    },

    /**
     * Overrides Backbone parse method. We don't want to sync this model with the information retrieved from the server.
     * @override
     */
    parse: function() {
        return {};
    },

    successCallback: function(model, newMetadata) {
        this.isResetRequested = this.event === 'Reset';
        this.metadata = newMetadata;
        // On filter change, we launch the request, once we receive the answer, we notify the rest of the filters about the new metadata.
        this.notifySubscribers(this.metadata, this.isResetRequested);
        this.resetModel(this.isResetRequested);
        // We notify the handler that a new set of accommodation results is ready.
        Odigeo.trigger(this.widget.id + ':accommodation' + this.event + 'Succesfully', this.metadata);
    },

    errorCallback: function() {
        Odigeo.trigger(this.widget.id + ':accommodation' + this.event + 'Error');
    },

    onFilterHasChanged: function(ev, filterUpdate) {
        this.set(filterUpdate);
    },

    onUpdateFilterStatus: function() {
        if (this.metadata) {
            this.notifySubscribers(this.metadata, this.isResetRequested);
        }
    },

    notifySubscribers: function(filtersState, isResetRequested) {
        Odigeo._.each(this.widget.subscribers, function(subscriber) {
            $(subscriber).trigger('updateFilterStatus.accommodationfilter', [filtersState, isResetRequested]);
        }, this);
    },

    resetModel: function(isResetRequested) {
        if (isResetRequested) {
            this.clear({silent: true});
        }
    },

    update: function(filtersState) {
        if (hasToResetFilters.call(this, filtersState)) {
            this.resetModel(true);
            this.notifySubscribers(filtersState, true);
        } else {
            this.notifySubscribers(filtersState, false);
        }
    },

    refreshFilters: function() {
        this.requestFilter(this.toJSON());
    },
});
